import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import { RequestAction, RequestFailure } from '../RequestAction';
import { ArsenalUnitStep, Nullable } from '@Models';
import { ApiClient, arsenal_step_dto } from '@Api';
import { Locale } from '../locale';
import { ArsenalStepMapper } from '@Mapper/arsenal/arsenal-step.mapper';
import { RequestArsenalUnitStepSuccess } from './response';

@injectable()
export class ArsenalUnitStepRepository {
  @inject(TYPES.Mapper.ArsenalStepMapper)
  private _arsenalStepMapper!: ArsenalStepMapper;
  @inject(TYPES.Api.ApiClient) private _apiClient!: ApiClient;
  @inject(TYPES.Locale) private _locale!: Locale;

  public async create(
    unitId: string,
    unitStep: ArsenalUnitStep,
    locale?: Nullable<string>,
  ): Promise<RequestAction> {
    try {
      const body: arsenal_step_dto = this._arsenalStepMapper.mapDto(unitStep);

      const dto = await this._apiClient.arsenal.createUnitStep({
        id: unitId,
        locale: locale ?? this._locale.getlocale(),
        requestBody: body,
      });
      return new RequestArsenalUnitStepSuccess({
        payload: this._arsenalStepMapper.map(dto),
      });
    } catch (error: any) {
      return new RequestFailure({ error: error });
    }
  }

  public async update(
    unitStep: ArsenalUnitStep,
    locale?: Nullable<string>,
  ): Promise<RequestAction> {
    try {
      const body = this._arsenalStepMapper.mapDto(unitStep);

      const dto = await this._apiClient.arsenal.updateUnitStep({
        locale: locale ?? this._locale.getlocale(),
        id: unitStep.id,
        requestBody: body,
      });

      return new RequestArsenalUnitStepSuccess({
        payload: this._arsenalStepMapper.map(dto),
      });
    } catch (error: any) {
      return new RequestFailure({ error: error });
    }
  }
}
